import CssBaseline from '@mui/material/CssBaseline'
import Stack from '@mui/material/Stack'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Link from '../components/Link'
import logo from '../assets/logo.svg'

type Props = { children: React.ReactNode }

const App: React.FC<Props> = ({ children }) => {
  return (
    <>
      <CssBaseline />
      <Stack
        sx={{
          width: '100%',
          minHeight: '100vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Stack
          sx={{
            justifyContent: 'end',
            flex: 1,
            padding: 2,
          }}
        >
          <Box
            sx={{
              marginBottom: 2,
              width: '264px',
            }}
          >
            <img src={logo} width="100%" />
          </Box>
        </Stack>
        <Stack
          sx={{
            flexDirection: 'column',
            justifyContent: 'center',
            padding: 2,
            flex: 1,
            width: '100%',
            alignItems: 'center',
          }}
        >
          <Card
            sx={{
              width: '350px',
              maxWidth: '100%',
              backgroundColor: 'white',
              borderRadius: '10px',
              border: '1px solid rgb(0,0,0,0.16)',
              padding: '12px',
              boxShadow: 0,
            }}
          >
            {children}
          </Card>
        </Stack>
        <Stack
          sx={{
            justifyContent: 'end',
            flex: 1,
            paddingBottom: 8,
          }}
        >
          <Link
            to="https://www.chainalysis.com/privacy-policy/"
            target="_blank"
            variant="body2"
            sx={{
              textDecoration: 'none',
            }}
          >
            Privacy policy
          </Link>
        </Stack>
      </Stack>
    </>
  )
}

export default App
